import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { LoadingService } from 'src/app/services/loading.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-stroop-incongruent',
    templateUrl: './stroop-incongruent.component.html',
    styleUrls: ['./stroop-incongruent.component.scss']
})
export class StroopIncongruentComponent implements OnInit, OnDestroy {

    constructor(
        private http: HttpService,
        public loading: LoadingService,
        private location: Location
    ) { }
    data: any[] = [];
    colors: any[] = [];
    numberOfQuiz: number = 1;
    totalQuiz: number = 0;
    percentQuiz: string = '0';
    currentQuiz: any = {};
    currentAnswer: any[] = [];
    assetUrl: any = null;
    point: number = 0;
    elapsedTime: number = 0;
    isDone: boolean = false;
    nextTimeout: any = null;
    answerList: any[] = [];
    startTime: number = 0;
    endTime: number = 0;
    countDownInterval: any = null;
    countDown: number = 3;
    graphImage: any = null;

    async getData(): Promise<void> {
        const r = await this.http.Get('quiz/stroop/incongruent', {}, true);
        if (!r.success) {
            this.location.back();
            return;
        }
        this.data = r.response?.result?.data || [];
        this.colors = r.response?.result?.colors || [];
        this.graphImage = r.response?.result?.image || null;
        this.totalQuiz = this.data.length || 1;
        this.percentQuiz = ((this.numberOfQuiz / this.totalQuiz) * 100).toFixed(0);
        this.data.sort(() => Math.random() - 0.5);
        this.colors.sort(() => Math.random() - 0.5);
        this.loading.done();
        this.countDownInterval = setInterval(() => {
            this.countDown--;
            if (this.countDown <= 0) {
                this.playQuiz();
                clearInterval(this.countDownInterval);
            }
        }, 1000);
    }

    playQuiz(): void {
        this.startTime = (new Date()).getTime();
        this.currentQuiz = this.data[this.numberOfQuiz - 1] || {};
        this.currentAnswer = this.colors?.filter((e: any) => e.id != this.currentQuiz.color_code_id);
        this.currentAnswer.push(this.currentQuiz.color_code);
        this.currentAnswer.sort(() => Math.random() - 0.5);
        this.playAudio();
    }

    nextQuiz(): void {
        this.endTime = (new Date()).getTime();
        this.elapsedTime += (this.endTime - this.startTime);
        clearTimeout(this.nextTimeout);
        if (this.numberOfQuiz >= this.totalQuiz) {
            this.isDone = true;
            this.postResult();
            return;
        }
        this.numberOfQuiz++;
        this.percentQuiz = ((this.numberOfQuiz / this.totalQuiz) * 100).toFixed(0);
        this.playQuiz();
    }

    answerQuiz(item: any = {}): void {
        if (this.isDone) {
            this.postResult();
            return;
        }
        this.point += (item.id == this.currentQuiz.color_code_id ? this.currentQuiz.point : 0);
        this.nextQuiz();
    }

    async postResult(): Promise<void> {
        let seconds = this.elapsedTime;
        let d = new Date(0);
        d.setMilliseconds(seconds);
        let ts = d.toISOString().substring(11, 23) + '000';
        this.http.SaveQuiz('STROOP Test', 'Incongruent', this.point, ts);
    }

    playAudio(): void {
        if (!this.currentQuiz.voice) {
            return;
        }
        let audio = new Audio(this.assetUrl + this.currentQuiz.voice);
        audio.play();
    }

    ngOnInit(): void {
        this.loading.start();
        this.assetUrl = environment.assetUrl;
        this.getData();
    }

    ngOnDestroy(): void {
        clearTimeout(this.nextTimeout);
        clearInterval(this.countDownInterval);
    }

}
